import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment-timezone';
import 'moment/locale/es';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

// Toda la operación de Levita es en México (por ahora no se soporta otra
// zona horaria/locale). Se configura una sola vez aquí porque moment usa un
// objeto compartido a nivel de módulo: cualquier import de 'moment' en
// cualquier archivo de la app apunta a esta misma instancia, así que no hace
// falta (ni conviene) repetir este setup por archivo.
moment.tz.setDefault('America/Mexico_City');
moment.locale('es', {
  week: {
    dow: 1, // Lunes como primer día de la semana
    doy: 4,
  },
});

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
